<script setup lang="ts">
import { isValidPairingCode, normalizePairingCode, PAIRING_CODE_LENGTH } from '~/utils/pairingCode'

const props = withDefaults(defineProps<{
  buttonBlock?: boolean
  initialCode?: string
}>(), {
  buttonBlock: true,
  initialCode: '',
})

const { data: ui } = useChallengeWheelUI()
const router = useRouter()
const route = useRoute()

const input = ref(normalizePairingCode(props.initialCode))
const errorMessage = ref<null | string>(null)

const isValid = computed(() => isValidPairingCode(input.value))

function handleInput(value: string) {
  input.value = normalizePairingCode(value)
  errorMessage.value = null
}

function submit() {
  if (!isValid.value) {
    errorMessage.value = ui.value?.setup.presentation.pairingCodeInvalid ?? 'Enter the full pairing code.'
    return
  }
  router.replace({
    query: {
      ...route.query,
      code: input.value,
      session: undefined,
      view: 'presenter',
    },
  })
}
</script>

<template>
  <form
    class="space-y-3"
    @submit.prevent="submit"
  >
    <UInput
      :model-value="input"
      :maxlength="PAIRING_CODE_LENGTH"
      autocomplete="off"
      autocapitalize="characters"
      spellcheck="false"
      :placeholder="ui?.setup.presentation.presenterPairingPlaceholder"
      size="xl"
      :ui="{
        base: 'text-center font-mono uppercase tracking-[0.4em] text-2xl',
      }"
      @update:model-value="handleInput(String($event))"
    />

    <p
      v-if="errorMessage"
      class="text-sm text-error"
    >
      {{ errorMessage }}
    </p>

    <UButton
      :block="props.buttonBlock"
      :disabled="!isValid"
      icon="mdi:connection"
      :label="ui?.setup.presentation.presenterPairingConnectButton"
      size="lg"
      type="submit"
    />
  </form>
</template>
